import './App.css';
// import CryptoCard from './Components/CryptoCard';
import Header from './Components/Header';

function App() {
  return (
    <div className="App">
      <Header/> {/* <CryptoCard/> */}
    </div>
  );
}

export default App;

     